import { MINIAPP_SHARE_URL } from "@/constants/url";
import style from "./Intro.module.scss";

export default function Intro() {
  return (
    <div className={style.wrapper}>
      <button
        className={`${style.startButton} button-flat`}
        onClick={() => window.open(MINIAPP_SHARE_URL, "_blank")}
      >
        Start
      </button>
    </div>
  );
}
